import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';
import RadioElement from '@/views/elements/radio/RadioElement';
import React, { useState } from 'react';

export default function RadioButtonsGroup({ data, onTransferValue, value }: { data: { label: string, value: string }[], onTransferValue: any, value: string }) {

    const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        onTransferValue((event.target as HTMLInputElement).value);
    };

    return (
        <FormControl>
            {/* <FormLabel id="demo-radio-buttons-group-label">Gender</FormLabel> */}
            <RadioGroup
                aria-labelledby="demo-radio-buttons-group-label"
                defaultValue="female"
                name="radio-buttons-group"
                value={value}
                onChange={handleChange}
            >
                {
                    data.map((radioItem: { label: string, value: string }) => {
                        return (<FormControlLabel value={radioItem?.value} control={<RadioElement />} label={radioItem?.label} />)
                    })
                }

            </RadioGroup>
        </FormControl>
    );
}
